import { useContext } from 'react';
import { NodeSelection } from '@tiptap/pm/state';
import type { BubbleMenuProps } from '@tiptap/react/menus';

import DocumentContext from '../../../contexts/DocumentContext.context';
import NodeBubbleMenuShell from '../../../components/NodeBubbleMenuShell';
import { TEMPLATE_FIELD_BLOCK_NAME, TEMPLATE_FIELD_INLINE_NAME } from '../../../doc-engine/templateFields';
import { findSelectedField } from '../formField/formFieldHelpers';
import { handleSettingsHistoryKeys } from './fieldSettings';
import FieldSettingsControls from './FieldSettingsControls';

// Content text shows its settings popup only while the field itself is selected, so the popup does not cover the text being typed.
const SHOWS_POPUP: Record<string, NonNullable<BubbleMenuProps['shouldShow']>> = {
  [TEMPLATE_FIELD_INLINE_NAME]: ({ state }) => !!findSelectedField(state, TEMPLATE_FIELD_INLINE_NAME),
  [TEMPLATE_FIELD_BLOCK_NAME]: ({ state }) =>
    state.selection instanceof NodeSelection && !!findSelectedField(state, TEMPLATE_FIELD_BLOCK_NAME),
};

/** The settings popup of an Inline text field, or of a Content text field that is not in a card. */
const FieldSettingsBubbleMenu = () => {
  const { editor, isEdit } = useContext(DocumentContext);

  return (
    <>
      {[TEMPLATE_FIELD_INLINE_NAME, TEMPLATE_FIELD_BLOCK_NAME].map((nodeName) => (
        <NodeBubbleMenuShell
          key={nodeName}
          nodeName={nodeName}
          editor={editor}
          isEdit={isEdit}
          extraPredicate={SHOWS_POPUP[nodeName]}
          paddingCard="medium"
        >
          <div className="w-64" onKeyDown={(event) => handleSettingsHistoryKeys(editor, event)}>
            <FieldSettingsControls nodeName={nodeName} />
          </div>
        </NodeBubbleMenuShell>
      ))}
    </>
  );
};

export default FieldSettingsBubbleMenu;
